/** @graphql cc **/
import gql from 'graphql-tag';

import { getApolloClient } from '@confluence/graphql/entry-points/getApolloClient';

import {
	SitePermissionType,
	type FetchPresenceUsersGuestStatusQuery as UsersQuery$data,
	type FetchPresenceUsersGuestStatusQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceUsersGuestStatusQuery';

export const fetchPresenceUsersGuestStatus = (accountIds: string[]) => {
	return getApolloClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceUsersGuestStatusQuery($accountIds: [String]) {
					confluenceUsers(accountIds: $accountIds) {
						nodes {
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
							permissionType
						}
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.confluenceUsers?.nodes
					?.filter((user: any) => user?.accountId)
					.map((user: any) => ({
						userId: user?.accountId ?? '',
						isGuest: user?.permissionType === SitePermissionType.EXTERNAL ?? undefined,
					})) ?? []
			);
		});
};
